export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080'

// AWS Account configuration
export interface AWSAccount {
  id: string
  alias: string
  environment: 'prod' | 'staging'
}

export const AWS_ACCOUNTS: AWSAccount[] = [
  { id: '423191951588', alias: 'Production', environment: 'prod' },
  { id: '945723768054', alias: 'Staging', environment: 'staging' },
]

export function getAccountAlias(accountId: string): string {
  const account = AWS_ACCOUNTS.find((a) => a.id === accountId)
  return account?.alias || accountId
}

export function getAccountEnvironment(accountId: string): 'prod' | 'staging' | null {
  const account = AWS_ACCOUNTS.find((a) => a.id === accountId)
  return account?.environment || null
}

export interface ApiError {
  error: string
}

export interface LoginResponse {
  token: string
}

export interface User {
  username: string
  role: string
}

export interface DnsRecord {
  type: string
  name: string
  content: string
  priority?: number
}

export interface IdentityInfo {
  account_id: string
  domain: string
  status?: string
  verification_status: string
  dkim_status: string
  dns_records?: DnsRecord[]
  configuration_set_name: string
  identity_type?: string
  created_at: string
  updated_at: string
}

export interface DomainResponse {
  identity_info: IdentityInfo
  error?: string
}

// Alias for backward compatibility
export type Domain = IdentityInfo
export type DomainInfo = IdentityInfo

export interface VerifyDomainRequest {
  account_id: string
  domain: string
  configuration_set?: string
  mail_from_subdomain?: string
}

export interface BulkVerifyRequest {
  account_id: string
  configuration_set_name?: string
  mail_from_subdomain?: string
  domains: string[]
}

export interface BulkJobCreateResponse {
  job_id: string
  status: string
  total: number
  message: string
}

export interface BulkJobSummary {
  job_id: string
  account_id: string
  status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED'
  total: number
  processed: number
  success_count: number
  failure_count: number
  created_by: string
  created_at: string
  updated_at: string
}

export interface BulkJobDomainResult {
  domain: string
  success: boolean
  error?: string
}

export interface BulkJobStatusResponse {
  job_id: string
  account_id: string
  status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED'
  total: number
  processed: number
  success_count: number
  failure_count: number
  results?: BulkJobDomainResult[]
  created_at: string
  updated_at: string
}

export interface CreateUserRequest {
  login: string
  password: string
  role: string
}

export interface CreateUserResponse {
  login: string
  role: string
  created_at: string
}

export interface UserInfo {
  login: string
  role: string
  is_active: boolean
  created_at: string
  updated_at: string
}

export interface ListUsersResponse {
  users: UserInfo[]
  count: number
}

export interface DeleteUserRequest {
  login: string
}

export interface ResetPasswordRequest {
  login: string
  new_password: string
}

export interface MessageResponse {
  message: string
}

export interface ListDomainsResponse {
  domains: Domain[]
  count: number
  total: number
  next_cursor?: string
}

export interface ListDomainsParams {
  search?: string
  status?: string
  account_id?: string
  limit?: number
  cursor?: string
}

export interface DeleteDomainResponse {
  message: string
}

export interface VerificationStatusResponse {
  execution_arn?: string
  status: string
  start_time?: string
  stop_time?: string
  domain: string
  account_id: string
  error?: string
}

export interface ActionResult<T> {
  success: boolean
  data?: T
  error?: string
}
